import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProductList from './ProductList';
import LoginPage from './LoginPage';
import Navbar from './Navbar';
import ProductAdminPanel from './ProductAdminPanel';
import { CartProvider } from './CartContext';
import CartPage from './CartPage';
import AboutPage from './AboutPage';
import './App.css';
import RouteChangeTracker from "./RouteChangeTracker";
import { CONTACT_PHONE, CONTACT_PHONE_LABEL, CONTACT_EMAIL } from './contacts';

function App() {
  return (
    <CartProvider>
      <Router>
        <RouteChangeTracker />
        <header>
          <div className="container glass-container">
            <div className="header-title-block">
              <img src="/mainlogo.svg" alt="Газстройпром ГСП Переработка" className="site-logo" />

              <div className="inline-contact">
                <a href={`tel:${CONTACT_PHONE}`}>{CONTACT_PHONE_LABEL}</a>
                <a href={`mailto:${CONTACT_EMAIL}`}>✉ {CONTACT_EMAIL}</a>
              </div>
            </div>

            <Navbar />
          </div>
        </header>

        <main>
          <div className="container">
            <Routes>
              <Route path="/" element={<ProductList />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/admin-panel" element={<ProductAdminPanel />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/about" element={<AboutPage />} />
            </Routes>
          </div>
        </main>
      </Router>
    </CartProvider>
  );
}

export default App;